import { Controller } from "@hotwired/stimulus"

const CHART_JS_SRC = "https://cdn.jsdelivr.net/npm/chart.js"
let chartLoaderPromise = null

function loadChartJs() {
    if (window.Chart) return Promise.resolve()
    if (chartLoaderPromise) return chartLoaderPromise

    chartLoaderPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.src = CHART_JS_SRC
        script.onload = () => resolve()
        script.onerror = () => reject(new Error("Failed to load Chart.js"))
        document.head.appendChild(script)
    })
    return chartLoaderPromise
}

export default class extends Controller {
    static values = {
        points: Array,
        label: { type: String, default: "" }
    }

    connect() {
        loadChartJs().then(() => this.draw()).catch((err) => console.error(err))
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
            this.chart = null
        }
    }

    draw() {
        if (!this.element.isConnected) return

        const labels = this.pointsValue.map((p) => p.date)
        const data = this.pointsValue.map((p) => p.count)

        this.chart = new Chart(this.element, {
            type: "line",
            data: {
                labels,
                datasets: [{
                    label: this.labelValue,
                    data,
                    borderColor: "rgb(49, 46, 129)",
                    backgroundColor: "rgba(99, 102, 241, 0.1)",
                    borderWidth: 2,
                    tension: 0.25,
                    fill: true,
                    pointRadius: 0,
                    pointHoverRadius: 4,
                    pointBackgroundColor: "rgb(49, 46, 129)"
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        intersect: false,
                        mode: "index",
                        displayColors: false,
                        callbacks: {
                            title: (items) => {
                                const iso = items[0].label
                                const d = new Date(iso)
                                return d.toLocaleDateString(undefined, { month: "short", day: "numeric" })
                            }
                        }
                    }
                },
                interaction: { mode: "index", intersect: false },
                scales: {
                    x: {
                        ticks: {
                            maxTicksLimit: 7,
                            color: "rgb(120, 113, 108)",
                            font: { size: 11 },
                            callback: function (value) {
                                const iso = this.getLabelForValue(value)
                                const d = new Date(iso)
                                return d.toLocaleDateString(undefined, { month: "short", day: "numeric" })
                            }
                        },
                        grid: { display: false }
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0,
                            color: "rgb(120, 113, 108)",
                            font: { size: 11 }
                        },
                        grid: { color: "rgba(231, 229, 228, 0.6)" }
                    }
                }
            }
        })
    }
}
